package com.exura.features.plandefinition.data.mappers.plandefinition

import com.exura.features.plandefinition.data.remote.dto.element.InstructionElementDto
import com.exura.features.plandefinition.domain.model.element.InstructionElement
import dev.gitlive.firebase.firestore.CollectionReference

/**
 * Mapper for converting between InstructionElement domain model and DTO.
 * Implements PlanElementMappers for Firebase storage compatibility.
 */
class InstructionElementMappers : PlanElementMappers<InstructionElement, InstructionElementDto> {
    override fun toDto(model: InstructionElement): InstructionElementDto = InstructionElementDto(
        elementType = model.elementType.name,
        durationInMinutes = model.durationInMinutes,
        durationInDays = model.durationInDays(),
        relativeDay = model.relativeDay,
        title = model.title,
        instruction = model.instruction,
        partOfDay = model.partOfDay,
        exactTime = model.exactTime,
        imageUrl = model.imageUrl,
    )

    override fun toDomain(dto: InstructionElementDto, collection: CollectionReference?, id: String?): InstructionElement = InstructionElement(
        firebaseDocId = id,
        firebaseDocPrefix = collection,
        title = dto.title,
        instruction = dto.instruction,
        imageUrl = dto.imageUrl,
        relativeDay = dto.relativeDay,
        partOfDay = dto.partOfDay,
        exactTime = dto.exactTime,
        durationInMinutes = dto.durationInMinutes,
    )
}
